"use client"
import type { FC, ReactNode } from "react"

export type SectionHeadingProps = {
  id?: string
  as?: "h1" | "h2" | "h3"
  align?: "left" | "center"
  className?: string
  children: ReactNode
}

/**
 * Роль выбирается уровнем, а не размером: h1 — Display (заголовок страницы),
 * h2/h3 — Headline (заголовок секции). Одна роль — один вид, поэтому
 * отдельного пропа размера нет.
 */
const SectionHeading: FC<SectionHeadingProps> = ({
  id,
  as = "h2",
  align = "center",
  className = "",
  children,
}) => {
  const Tag = as

  const roleClass = as === "h1" ? "text-display" : "text-headline"

  const alignClasses = align === "center" ? "text-center" : "text-left"

  return (
    <Tag id={id} className={[roleClass, alignClasses, className].join(" ")} tabIndex={0}>
      {children}
    </Tag>
  )
}

export default SectionHeading
